export const HIGHLIGHT_LEVELS = [
  'NORMAL',
  'HIGH',
  'HIGHEST'
];
